import { cloneElement, isValidElement, PropsWithChildren } from 'react';
import { useHint } from '../hint.context';
import { TriggerWrapper } from '../hint.styled';

export type TriggerProps = {
  asChild?: boolean;
};

export const Trigger = ({
  children,
  asChild = false,
}: PropsWithChildren<TriggerProps>) => {
  const { setOpen, triggerRef, contentId, open, triggerMode, closeImmediate } =
    useHint();

  const onKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Escape' && open) {
      closeImmediate();
    }
  };

  const props = {
    ref: triggerRef as React.Ref<HTMLElement>,
    tabIndex: 0,
    'aria-describedby': open ? contentId : undefined,
    onKeyDown,
    ...(triggerMode !== 'click' && {
      onMouseEnter: () => setOpen(true, 'hover'),
      onMouseLeave: () => setOpen(false, 'hover'),
      onFocus: () => setOpen(true, 'hover'),
      onBlur: () => setOpen(false, 'hover'),
    }),
    ...(triggerMode !== 'hover' && {
      onClick: () => setOpen(true, 'click'),
    }),
  };

  if (asChild && isValidElement(children)) {
    return cloneElement(children, props);
  }

  return <TriggerWrapper {...props}>{children}</TriggerWrapper>;
};
